import React from 'react';
// @ts-ignore
import { HorizontalRule } from 'arag-ui-lib';
import ClaimCommunicatorForm from './claimCommunicatorForm';
import ClaimCommunicatorComments, {
    Comments,
} from './claimCommunicatorComments';

type Props = {
    postCommunicatorMessageLoading: boolean;
    comments: Comments[];
    handleMessageSubmit: (values: any) => any;
    claimApplication: any;
    progressFileDownload: any;
    isLoadingDownload: null | string;
    clickDownloadHandler: Function;
    pagerState: any;
    goAtPrevious: Function;
    goAtNext: Function;
    goAtStart: Function;
    goAtEnd: Function;
    goAtPage: Function;
};
const ClaimCommunicator = (props: Props) => {
    const {
        postCommunicatorMessageLoading,
        comments,
        handleMessageSubmit,
        claimApplication,
        clickDownloadHandler,
        isLoadingDownload,
        progressFileDownload,
        pagerState,
        goAtPrevious,
        goAtNext,
        goAtStart,
        goAtEnd,
        goAtPage,
    } = props;

    return (
        <>
            <ClaimCommunicatorForm
                handleMessageSubmit={handleMessageSubmit}
                postCommunicatorMessageLoading={postCommunicatorMessageLoading}
                claimApplication={claimApplication}
            />
            <HorizontalRule />
            <ClaimCommunicatorComments
                comments={comments}
                progressFileDownload={progressFileDownload}
                isLoadingDownload={isLoadingDownload}
                clickDownloadHandler={clickDownloadHandler}
                pagerState={pagerState}
                goAtPrevious={goAtPrevious}
                goAtNext={goAtNext}
                goAtStart={goAtStart}
                goAtEnd={goAtEnd}
                goAtPage={goAtPage}
                isDisabled={claimApplication.isAnonymised}
            />
        </>
    );
};

export default ClaimCommunicator;
